import { CommonResponse, deleteData, get, patch, post, postFile } from './common.ts'

/**
 * (01)
 * 자료 목록 조회
 */

//  GET /documents/{subjectId}
interface GetDocumentsRequest {
  subjectId: string
  name: string
  sortBy: string
  onlyImage: boolean
}
interface GetDocumentsResponse {
  id: string
  fileName: string
  fileType: string
  fileSize: number
  isFavorite: boolean
  isNonImage: boolean
  isUploaded: boolean
  subjectId: string
  usedAt: string
  createdAt: string
}

export const getDocuments = async (
  request: GetDocumentsRequest,
): Promise<CommonResponse<GetDocumentsResponse>> => {
  const name = request.name ? `name=${request.name}` : ''
  const sortBy = request.sortBy ? `sortBy=${request.sortBy}` : ''
  const onlyImage = request.onlyImage ? `&onlyImage=${request.onlyImage}` : ''
  return await get(`/documents/${request.subjectId}?${name}&${sortBy}${onlyImage}`)
}

/**
 * (02)
 * 파일 업로드
 */

// POST /documents/{subjectId}/uploads
interface PostDocumentsUploadsRequest {
  subjectId: string
  action: string
}
interface PostDocumentsUploadsResponse {
  files: File
}

export const postDocumentsUploads = async (
  request: PostDocumentsUploadsRequest,
  body: PostDocumentsUploadsResponse,
  onUploadProgress?: (progress: number) => void,
): Promise<CommonResponse<null>> => {
  let form = new FormData()
  form.append('files', body.files)

  const action = request.action ? `?action=${request.action}` : ''
  return await postFile(`/documents/${request.subjectId}/uploads${action}`, form, onUploadProgress)
}

/**
 * (03)
 * 자료 삭제
 */

// DELETE /documents
interface DeleteDocumentsRequest {}

export const deleteDocuments = async (
  body: DeleteDocumentsRequest,
): Promise<CommonResponse<null>> => {
  return await deleteData('/documents', body)
}

/**
 * (04)
 * 파일 다운로드
 */

// POST /documents/download
interface PostDocumentsDownloadResponse {}

export const postDocumentsDownload = async (
  body: PostDocumentsDownloadResponse,
): Promise<CommonResponse<null>> => {
  return await post('/documents/download', body)
}

/**
 * (05)
 * 자료명 변경
 */

// PATCH /documents/rename
interface PatchDocumentsRenameRequestParams {
  isOrderName: Boolean
}
interface PatchDocumentsRenameRequestBody {
  documentId: string
  newName: string
}

export const patchDocumentsRename = async (
  request: PatchDocumentsRenameRequestParams,
  body: PatchDocumentsRenameRequestBody,
): Promise<CommonResponse<null>> => {
  const isOrderName = request.isOrderName ? `?isOrderName=${request.isOrderName}` : ''
  return await patch(`/documents/rename${isOrderName}`, body)
}

/**
 * (06)
 * 즐겨찾기
 */

// PATCH /documents/favorite
interface PatchDocumentsFavoriteRequest {
  documentIds: string[]
  isFavorite: boolean
}

export const patchDocumentsFavorite = async (
  body: PatchDocumentsFavoriteRequest,
): Promise<CommonResponse<null>> => {
  return await patch('/documents/favorite', body)
}

/**
 * (07)
 * 특정 자료 하위 이미지 가져오기
 */

// POST /documents/download/{documentId}
interface PostDocumentsDownloadImageRequestParams {
  documentId: string
}
interface PostDocumentsDownloadImageRequestBody {}

export const PostDocumentsDownloadImage = async (
  request: PostDocumentsDownloadImageRequestParams,
  body: PostDocumentsDownloadImageRequestBody,
): Promise<CommonResponse<null>> => {
  return await post(`/documents/download/${request.documentId}`, body)
}
